import { call, put } from 'redux-saga/effects';
import GetTimeslotsActions from '../redux/GetTimeslotsRedux';
import { api } from './api';
import { mergeArray } from '../utils/Helpers';

export function* getTimeslots(action: any): Generator<any, void, any> {
  const { leave_id, page, isTherapist, children_id, isReschedule, make_id } = action;
  
  const response = isTherapist 
  ? yield call(api.getTimeslotsTherapist, leave_id, children_id)
  : yield call(api.getTimeslots, leave_id, page);

  const responseUpdate = yield call(api.getMake, make_id);
  let responseMake = responseUpdate.data?.data?.data;

  let arrMakePush: Array<{ appointment_timeslot_id: any; option_schedule: any }> = [];
  responseMake.forEach((element: any) => {
    if (element.option_schedule !== 0) {
      arrMakePush.push({
        appointment_timeslot_id: element.appointment_timeslot_id,
        option_schedule: element.option_schedule,
      });
    }
  });
  console.log(isReschedule, responseUpdate, response);
  if (response.ok) {
    let a = isReschedule
      ? mergeArray(responseUpdate, response)
      : response.data?.data;
    yield put(GetTimeslotsActions.getTimeslotsSuccess(a, arrMakePush));
  } else {
    yield put(GetTimeslotsActions.getTimeslotsFailure());
  }
}